import { useAngularContext } from 'AngularContext';
import { type DateHelper } from 'DateHelper';

export function useDateHelper() {
    const $injector = useAngularContext();
    return $injector.get<DateHelper>('dateHelper');
}
